export enum PurchaseType {
  CASH = 'CASH',
  WALLET = 'WALLET',
  CAMPAIGN = 'CAMPAIGN',
  CARD = 'CARD',
  DIRECT = 'DIRECT',
  MEMBERSHIP = 'MEMBERSHIP',
  PHYSICAL_CARD = 'PHYSICAL_CARD',
  MEAL_CARD = 'MEAL_CARD',
  LOYALTY_POINTS = 'LOYALTY_POINTS',
  LOYALTY_POINTS_HYBRID = 'LOYALTY_POINTS_HYBRID',
  MIXED = 'MIXED',
  EXTERNAL_PLATFORM = 'EXTERNAL_PLATFORM',
  OPEN_ACCOUNT = 'OPEN_ACCOUNT'
}
